import { driver, type Driver, type DriveStep } from 'driver.js'
import 'driver.js/dist/driver.css'
import '@/assets/tour.css'

// A self-contained walkthrough for the public demo. Uses mostly centered
// informational steps so it works no matter which screen the visitor is on,
// and highlights the bottom dock when present to point at navigation.
export function useDemoTour() {
  let instance: Driver | null = null

  const buildSteps = (t: (key: string) => string): DriveStep[] => {
    const steps: DriveStep[] = [
      { popover: { title: t('demo.tour.welcome.title'), description: t('demo.tour.welcome.description') } },
      { popover: { title: t('demo.tour.data.title'), description: t('demo.tour.data.description') } },
      // Deliveries lead — the headline workflow the demo lands on.
      { popover: { title: t('demo.tour.deliveries.title'), description: t('demo.tour.deliveries.description') } },
      { popover: { title: t('demo.tour.sales.title'), description: t('demo.tour.sales.description') } },
      { popover: { title: t('demo.tour.settlements.title'), description: t('demo.tour.settlements.description') } }
    ]

    // Anchor a step on the dock if it is in the DOM on this screen.
    if (typeof document !== 'undefined' && document.querySelector('[data-tour="app-dock"]')) {
      steps.push({
        element: '[data-tour="app-dock"]',
        popover: {
          title: t('demo.tour.navigate.title'),
          description: t('demo.tour.navigate.description'),
          side: 'top',
          align: 'center'
        }
      })
    }

    steps.push({ popover: { title: t('demo.tour.end.title'), description: t('demo.tour.end.description') } })
    return steps
  }

  const startDemoTour = (t: (key: string) => string) => {
    if (instance) instance.destroy()

    instance = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      overlayColor: 'rgba(0, 0, 0, 0.6)',
      stagePadding: 10,
      stageRadius: 8,
      popoverClass: 'hudstore-tour-popover',
      showButtons: ['next', 'previous', 'close'],
      nextBtnText: t('tour.buttons.next'),
      prevBtnText: t('tour.buttons.previous'),
      doneBtnText: t('tour.buttons.done'),
      onDestroyed: () => {
        instance = null
      },
      steps: buildSteps(t)
    })

    instance.drive()
  }

  const stopDemoTour = () => {
    if (instance) {
      instance.destroy()
      instance = null
    }
  }

  return { startDemoTour, stopDemoTour }
}
